<template>
  <form @submit.prevent="handleCreatePayCode" class="add-paycode">
            <h3>Cerate new PayCode</h3>
            <div class="uk-margin">
                <label class="uk-form-label" for="form-stacked-text">Title or company name</label>
                <div class="uk-form-controls">
                    <input
                    :class="{
                        'uk-input': true,
                        'uk-form-danger': errors.has('title')
                    }"
                    type="text"
                    name="title"
                    v-validate="'required'"
                    v-model="paycode.title">
                    <div v-if="submitted && errors.has('title')" class="uk-text-danger">{{errors.first('title')}}</div>
                </div>
            </div>
            <div class="uk-margin">
                <label class="uk-form-label" for="form-stacked-code">PayCode (generated automatically)</label>
                <div class="uk-form-controls">
                    <input
                    :class="{
                        'uk-input': true,
                        'uk-form-danger': errors.has('code')
                    }"
                    type="text"
                    name="code"
                    v-validate="'required'"
                    v-model="paycode.code">
                    <div v-if="submitted && errors.has('code')" class="uk-text-danger">{{errors.first('code')}}</div>
                </div>
            </div>
            <div class="uk-margin uk-text-center">
                <button class="uk-button uk-button-primary uk-width-1-4" :disabled="successful">Create</button>
            </div>
            <p v-if="message" class="uk-text-center uk-text-small" :class="successful ? 'uk-text-success' : 'uk-text-danger'">{{message}}</p>
      </form>
</template>

<script>
import PayCode from '@/models/paycode';
import PayCodeService from '@/services/paycode.service';
export default {
    name: 'Create',
    data() {
        return {
            paycode: new PayCode('', Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)),
            message: '',
            successful: false,
            submitted: false
        }
    },
    methods: {
        handleCreatePayCode() {
            this.message = '';
            this.submitted = true;
            this.$validator.validate().then(isValid => {
                if (isValid) {
                    PayCodeService.create(this.paycode).then(
                        res => {
                            this.message = res.data.message;
                            this.successful = true;
                            setTimeout(() =>  this.$router.go(-1), 3000);
                        },
                        error => {
                            this.message = 
                            (error.response && error.response.data.message) ||
                            error.message || error.toString();
                            this.successful = false;
                        }
                    );
                }
            });
        }
    }
}
</script>

<style>
form.add-paycode {
    width: 400px;
}
</style>